define(function(require) {
	const tpl = require('civicsViews/map_view/templates/t_lov_results_view.hbs');
	const results_list_view = require('civicsViews/map_view/v_cpv_results_list_view')
	return Marionette.LayoutView.extend({
		className: 'modal-search-results',
		template: tpl,
		ui:{
			resultsListDiv:'.results-list-region',
			addSiteButton: '.add-site-button',
			clearAll:'.clear-all',
			cancelButton:'.cancel-button'
		},
		regions:{
			resultsListRegion:'@ui.resultsListDiv'
		},
		events: {
			'click @ui.cancelButton': 'cancelClicked',
			'click @ui.addSiteButton': 'addSiteClicked',
			'click @ui.clearAll':'clearAllClicked'
		},
		childEvents: {
			'radioButton:clicked': 'siteSelected'
		},
		views:{},
		initialize: function(options) {
			this.config = options.config;
			this.listCollection = options.collection;
		},

		onShow:function(){
		},
		onRender: function() {
			this.views.resultsListView = new results_list_view({
				config:this.config,
				collection:this.listCollection
			});
			this.resultsListRegion.show(this.views.resultsListView);

		},
		clearAllClicked:function(e){
			if(e.preventDefault){
				e.preventDefault();
			}
			this.triggerMethod('clearAllClicked');
		},
		siteSelected:function(childView, selectedSiteID, description, model){
			this.triggerMethod('siteSelected',selectedSiteID, description, model);
			this.ui.addSiteButton.removeAttr('disabled');

		},
		templateHelpers: function() {
			return {
				noResults:this.listCollection.length == 0
			}
		}
	});
});
